export default __webpack_public_path__ + "static/media/Meditation.f422066f.png";